const scrollToSection = (hash, yOffset = 0) => {
  const to = document.querySelector(hash);

  if (to) {
    const yCoordinate = to.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: yCoordinate + yOffset,
      behavior: 'smooth'
    });
  }
};

export default scrollToSection;